<template>
    <tr class="venue__list_table_item">
        <td class="venue__list_table_name">{{venueName}}</td>
        <td class="venue__list_table_rooms">{{venueRoomsCount}}</td>
        <td class="venue__list_table_status">
            <component-status :status="venueStatus"/>
        </td>
        <td class="venue__list_table_actions">
            <div class="columns is-inline-block is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                  <component-button
                    :theme="'default'"
                    :to="{ name: 'ebs-venue-show', params: { id: venueId } }"
                    :name="`enue-list-table-actions-view-${venueId}`"
                  >{{ $t('ebs.venues.list.buttons.view') }}</component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: { ComponentButton, ComponentStatus },
  name: 'venue-list-table-item',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    venueId: function () {
      return this.item.id
    },
    venueName: function () {
      return this.item.name
    },
    venueStatus: function () {
      return this.item.status
    },
    venueRoomsCount: function () {
      if (this.item.rooms) {
        return this.item.rooms.length === 1 ? `${this.item.rooms.length} ${this.$t('ebs.venues.list.return.room')}` : `${this.item.rooms.length} ${this.$t('ebs.venues.list.return.rooms')}`
      }
      return false
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/venues/venuelisttableitem";
</style>
